<template>
  
  <v-treeview 
    class     = "property-tree"
    dense 
    :items    = "mappedProperties"
    :open.sync= "expandedProperties"
    open-on-click
  >
    <template v-slot:label="{ item }">
      <PropertyTreeNode :item="item"></PropertyTreeNode>
    </template>
  </v-treeview>

</template>

<script>

// #region Imports

/* Telestream */
import PropertyTreeNode from './PropertyTreeNode';

// #endregion Imports

export default {

  // #region Properties

  props: {
    properties: Array
  },
  data() {
    return {
      expandedProperties: []
    };
  },
  computed: {
    mappedProperties() {
      if (!this.properties) {
        return [];
      }

      return this.properties.map((p, i) => this.mapProperty(p, 0, i));
    }
  },
  components: {
    PropertyTreeNode
  },

  // #endregion Properties

  // #region Methods

  methods: {

    // #region API

    collapseAll() {
      this.expandedProperties = [];
    },

    expandAll() {
      this.expandedProperties = [];

      const getIds = function(property, output) {
        output.push(property.id);
        if (property.children) {
          property.children.forEach(c => getIds(c, output));
        }
      }

      this.mappedProperties.forEach(p => getIds(p, this.expandedProperties));
    },

    // #endregion API

    // #region Utilities

    mapProperty(property, level, index) {
      const result = {};

      result.name = this.$i18n.t(property.name);
      result.id = `${level}_${index}`;  // For selection.

      if (property.description != null) {
        result.value = property.description;
      } else if (property.value != null) {
        result.value = property.value;
      }

      if (this.$i18n.te(property.name + '_description')) {
        result.tooltip = this.$i18n.t(property.name + '_description');
      }

      // If there are no children, we are done.
      if ((!property.children) || (property.children.length < 1)) {
        return result;
      }

      result.children = property.children.map((c, i) => this.mapProperty(c, level + 1, i));

      // TODO: Why?
      if (result.name === 'type') {
        if (property.children[0].description !== null) {
          result.name = property.children[0].description;
        } else {
          result.name = property.children[0].value;
        }
        result.children.shift();
      }

      return result;
    }

    // #endregion Utilities

  }

  // #endregion Methods

}

</script>

<style lang="scss">

.property-tree {
  .v-treeview-node__label {
    overflow:       initial;
    text-overflow:  initial;
  }

  .v-navigation-drawer__content {
    overflow-x:     auto
  }
}
</style>